import React, { useContext, useState } from 'react'
import { Switch, Route } from 'react-router-dom';

import {
    ALERTS, DASHBOARD, ALLALERTS, MYALERTS, ALERTDETAILS, ALLNOTIFICATIONS, REPORTS, ALERTARMDISARMREPORT, PROFILE, CAMERAS,
    CHATFLOW, ALERTREPORT, CAMERA_SINGLE_PLAYBACK, HEALTHMONITORING, DISPLAYSITE, EVENTACTIVITYREPORT, PAGE, DOWNLOAD, HOMEPAGE,
    ABOUTTERMS,
    PANELCONTROL,
    PANELACTIVITY,
    CUSTOMERACTIVITY,
    CUSTOMERSITEACTIVITY,
    OPERATORALERTREPORT,
    DAILYHEALTHCHECKREPORT,
    PANELUPDOWNREPORT,
    ATMSITEREPORT,
    ALERTGRIDVIEW,
    CAMERASOLD,
    AVAILABLERECORDINGREPORT,
    DASHBOARDCHARTS,
    CENTRALIZERECORDING,
    QUALITYCONTROL,
    DASHBOARDCONFIG,
    ORG_DASHBOARDCONFIG,
    MAIN_ORG,
    REPORTS_ONE,
    DeviceInstallationReport,
    DeviceStageReport,
    REPORT_INDEX,
    REPORT_VIEW,
    DASHBOARD1,
    DASHBOARD2
    
} from '../../navigation/CONSTANTS';
import PrivateRoute from '../../navigation/Auth/PrivateRoute';
import { DrawerContext } from '../../Context/DrawerContext';
import Sidebar from '../../components/Sidebar/Sidebar';
import DashboardContainer from '../Homepage/DashboardContainer';
// import ProfileContainer from '../Profile/ProfileContainer';
// import AlertsContainer from '../Alerts/AlertsContainer';
// import AllAlerts from '../Alerts/AllAlerts';
// import MyAlerts from '../Alerts/MyAlerts';
// import AlertDetails from '../Alerts/AlertDetails';
// import AlertReportContainer from '../Alerts/AlertReportContainer'
import ChatflowPageContainer from '../Chatflow/ChatflowPageContainer';
import CameraViewPage from '../Cameras/CameraViewPage';
// import SinglePlayback from '../Cameras/SinglePlayback';
import AllNotificationContainer from '../Notification/Allnotificationspage'
import HealthMonitoring from '../HealthMonitoring/HealthMonitoring';
import HealthDisplaySite from '../HealthMonitoring/HealthDisplaySite';
 import DownloadHistory from '../DownloadHistory/DownloadHistory';
// import AlertArmDisarmReport from '../Reports/AlertArmDisarmReport';
// import AlertReportsContainer from '../Reports/AlertReportsContainer';
import { CAMERA_NEW } from '../../config';
import CustomUrlPage from '../Homepage/CustomUrlPage';
import Termscondition from '../AboutMH/Termscondition';
// import PanelSetting from '../PanelControl/PanelSetting';
// import CommonReport from '../Reports/CommonReport';
// import CameraFilterPage from '../CameraNewUI/CameraFilterPage';
// import AlertMosaicView1 from '../Alerts/AlertMosaicView1';
import DashboardModule from '../Dashboard/DashboardModule';
import { CentralizeRecording } from '../CentralizeRecording/CentralizeRecording';

import withLazyLoad from '../../HOC/withLazyLoad';
import DashboardConfigMain from '../DashboardConfig/DashboardConfigMain';
import OrgDashboard from '../DashboardConfig/OrgDashboard';
import MainOrg from '../DashboardConfig/OrgLevel/MainOrg';
import withAccessAllowed from '../../HOC/withAccessAllowed';
import { AlertsModule } from '../../utils/ModuleConstants';
import ReportIndex from '../ReportsConfig/ReportIndex';
import ReportView from '../ReportsConfig/ReportView';
import Dashboard from '../ConfigurableDashboard/Dashboard';
import { Modal } from 'react-bootstrap';
import TableDetails from '../ConfigurableDashboard/Widget/TableDetails';
import { RemoveIcon } from '../../assets/images';
import { getAlertDataDetailed, getConsolidatedDataDetailed, getDeviceDataDetailed } from '../../services/dashboardService';
import { createExportRequestParams } from '../ConfigurableDashboard/DashboardUtils';

const LazyAllAlerts = withLazyLoad(() => import(/* webpackChunkName: "LazyAlertComponent" */'../Alerts/AllAlerts'));

//Some Issue in the below related to chart need to check later.
// const LazyHealthMonitoring = React.lazy(() => import(/* webpackChunkName: "LazyHealthMonitoringComponent" */'../HealthMonitoring/HealthMonitoring'))

const LazyPanelSetting = withLazyLoad(() => import(/* webpackChunkName: "LazyPanelControlComponent" */'../PanelControl/PanelSetting'))

const LazyAlertReportContainer = withLazyLoad(() => import(/* webpackChunkName: "LazyAlertReportComponent" */'../Alerts/AlertReportContainer'))

const LazyAlertMosaicView1 = withLazyLoad(() => import(/* webpackChunkName: "LazyAlertMosaicComponent"  */ '../Alerts/AlertMosaicView1'))

const LazyAlertDetails = withLazyLoad(() => import(/* webpackChunkName: "LazyAlertDetailComponent" */'../Alerts/AlertDetails'))

const LazyProfileContainer = withLazyLoad(() => import(/* webpackChunkName: "LazyProfileComponent" */ '../Profile/ProfileContainer'))

const LazyAlertsContainer = withLazyLoad(() => import(/* webpackChunkName: "LazyAlertsComponent" */ '../Alerts/AlertsContainer'))

const LazyMyAlerts = withLazyLoad(() => import(/* webpackChunkName: "LazyMyAlertsComponent" */'../Alerts/MyAlerts'))

// const LazyCameraViewPage = withLazyLoad(() => import(/* webpackChunkName: "LazyCameraViewPageComponent" */ '../Cameras/CameraViewPage'))

const LazyCameraFilterPage = withLazyLoad(() => import(/* webpackChunkName: "LazyCameraFilterPageComponent" */'../CameraNewUI/CameraFilterPage'))

const LazyQCCameraFilterPage = withLazyLoad(() => import(/* webpackChunkName: "LazyCameraFilterPageComponent" */'../CameraNewUI/QCCameraFilterPage'))

// const LazyTermscondition = withLazyLoad(() => import(/* webpackChunkName: "LazyTermsConditionPageComponent" */ '../AboutMH/Termscondition'))

const LazySinglePlayback = withLazyLoad(() => import(/* webpackChunkName: "LazySinglePlayback" */ '../Cameras/SinglePlayback'))

const LazyNotFound = withLazyLoad(() => import(/* webpackChunkName: "LazyNotFound" */'../../navigation/NotFound'))

const CommonReport = withLazyLoad(() => import(/* webpackChunkName: "LazyCommonReport" */ '../Reports/CommonReport'))

let getMenusAccess = JSON.parse(localStorage.getItem('user'));
let menusAccess = getMenusAccess?.MenuList;

const checkViewOperation = (menuName) => {
    const menu = menusAccess?.find((item) => item.Menuname === menuName);
    return menu ? menu.ViewOperation : false;
};

const ProtectedPanelSetting = withAccessAllowed(LazyPanelSetting, checkViewOperation("Panel Control"))

const ProtectedHealthMonitoring = withAccessAllowed(HealthMonitoring, checkViewOperation("Health Monitoring"))

const ProtectedQC = withAccessAllowed(LazyQCCameraFilterPage, checkViewOperation('Quality Control'))

const ProtectedAllAlerts = withAccessAllowed(LazyAllAlerts, checkViewOperation(AlertsModule))

const ProtectedCamera = withAccessAllowed(LazyCameraFilterPage, checkViewOperation('Cameras'))

const ProtectedReports = withAccessAllowed(CommonReport, checkViewOperation('Reports'))

const ProtectedCentralizeRecording = withAccessAllowed(CentralizeRecording, checkViewOperation('Video Backup'))

const ProtectedAlertDetails = withAccessAllowed(LazyAlertDetails, checkViewOperation('Alerts'))

const ProtectedAlertReport = withAccessAllowed(LazyAlertReportContainer, checkViewOperation('Alerts'))

const ProtectedAlertMosaic = withAccessAllowed(LazyAlertMosaicView1, checkViewOperation('Alerts'))

export default function MainContent({
    alerts,
    onAddAlertChat,
    ResetAlertList,
    selectedTab,
    setSelectedTab,
    selectedSubMenu,
    setSelectedSubMenu,
    alertcounts,
    rootLoading,
    ResetAlertCounts,
    todaysAlertList,
    isSuperUser,
    uniqueId,
    cctvTypeName,
    camUserName,
    camPassword,
    brandName,
    hootWay,
    setHootWay,
    alertSearch,
    setAlertSearch,
    activeSeverity,
    setActiveSeverity,
    childWindow,
    setChildWindow,
    isDarkTheme,
    setAlertDetail,
    setOpenButton1,
    openButton1,
    activeCam,
    setActiveCam,
    setCctvTypeName,
    setCamUserName,
    setCamPassword,
    setBrandName,
    associateCam,
    setAssociateCam,
    checkEnableSound,
    alertChildWindow,
    setAlertChildWindow,
    onCloseAlertOnDeviceId
}) {

    const { collapsed} = useContext(DrawerContext);
    const [currentReport, setCurrentReport] = useState(null);
    const [reportFromDate, setReportFromDate] = useState(null);
    const [reportToDate, setReportToDate] = useState(null);

    const [show, setShow] = useState();

    const [dashboardTableDataLoading, setDashboardTableDataLoading] = useState(false);
    const [dashboardTableDataError, setDashboardTableDataError] = useState(null);
    const [dashboardTableData, setDashboardTableData] = useState([]);
    const [tableRequestParams, setTableRequestParams] = useState(null);

    const [ csvFileName, setCSVFileName ] = useState('table-data')
    const [modalHeader, setModalHeader] = useState("");


    const handleModalShow = (filter, API, DateRange, filters = {}, csvFileName = 'table-data', widgetName, Datapoints={}) => {
        setShow(true);
        setDashboardTableDataLoading(true);
        setDashboardTableDataError(null);

        setCSVFileName(csvFileName);

        setModalHeader(widgetName);

        const user = JSON.parse(localStorage.getItem("user"));
        const UserID = user?.Id;

        let FromDateTime = "";
        let ToDateTime = "";

        if (typeof DateRange === "number") {
            // If widget has DateRange as int, calculate dates
            const now = new Date();
            // ToDateTime: today at 23:59:59
            const toDate = new Date(
                now.getFullYear(),
                now.getMonth(),
                now.getDate(),
                23,
                59,
                59,
                999
            );
            // FromDateTime: (today - (DateRange - 1)) at 00:00:00
            const fromDate = new Date(toDate);
            fromDate.setDate(toDate.getDate() - (DateRange - 1));
            fromDate.setHours(0, 0, 0, 0);

            const pad = (n) => n.toString().padStart(2, "0");
            const formatDate = (date) =>
                date.getFullYear() +
                "-" +
                pad(date.getMonth() + 1) +
                "-" +
                pad(date.getDate()) +
                " " +
                pad(date.getHours()) +
                ":" +
                pad(date.getMinutes()) +
                ":" +
                pad(date.getSeconds());

            FromDateTime = formatDate(fromDate);
            ToDateTime = formatDate(toDate);
        } else if (typeof DateRange === "object" && DateRange !== null) {
            // If DateRange is an object, use its FromDateTime and ToDateTime
            FromDateTime = DateRange.FromDateTime || "";
            ToDateTime = DateRange.ToDateTime || "";
        }

        if (API === "Alert") {
            const payload = {
                Filter: filter,
                filters: filters,
                UserID: UserID,
                FromDateTime,
                ToDateTime,
            };
            setTableRequestParams(createExportRequestParams(payload, "Alert"));
            getAlertDataDetailed(payload)
                .then((res) => {
                    if (res && res.Status === "success") {
                        setDashboardTableData(res.Data || []);
                    } else {
                        setDashboardTableDataError("Failed to load table data.");
                    }
                    setDashboardTableDataLoading(false);
                })
                .catch((err) => {
                    setDashboardTableDataError("Error loading table data.");
                    setDashboardTableDataLoading(false);
                    console.log("Error in TableDetails component: ", err);
                });
        } else if (API === "Master") {
            const payload = { Filter: filter, UserID: UserID, filters: filters,  FromDateTime, ToDateTime };
            setTableRequestParams(createExportRequestParams(payload, "Master"));
            getConsolidatedDataDetailed(payload)
                .then((res) => {
                    if (res && res.Status === "success") {
                        setDashboardTableData(res.Data || []);
                    } else {
                        setDashboardTableDataError("Failed to load table data.");
                    }
                    setDashboardTableDataLoading(false);
                })
                .catch((err) => {
                    setDashboardTableDataError("Error loading table data.");
                    setDashboardTableDataLoading(false);
                    console.log("Error in TableDetails component: ", err);
                });
        } else if (API === "DeviceStatus") {
            const payload = { Filter: filter, 
                UserID: UserID, 
                filters: filters, 
                FromDateTime, 
                ToDateTime, 
                Datapoints };
            setTableRequestParams(createExportRequestParams(payload, "DeviceStatus"));
            getDeviceDataDetailed(payload)
                .then((res) => {
                    if (res && res.Status === "success") {
                        setDashboardTableData(res.Data || []);
                    } else {
                        setDashboardTableDataError("Failed to load table data.");
                    }
                    setDashboardTableDataLoading(false);
                })
                .catch((err) => {
                    setDashboardTableDataError("Error loading table data.");
                    setDashboardTableDataLoading(false);
                    console.log("Error in TableDetails component: ", err);
                });
        } else {
            setDashboardTableData([]);
            setDashboardTableDataLoading(false);
        }
    };


    return <>
        <Sidebar
            isSuperUser={isSuperUser}
            selectedTab={selectedTab}
            setSelectedTab={setSelectedTab}
            selectedSubMenu={selectedSubMenu}
            setSelectedSubMenu={setSelectedSubMenu} />
        <div className={!collapsed ? "collapseMainContent" : "mainContent"} >
            <Switch>
                {/* <PrivateRoute path={ALERTS}>
                    <LazyAlertsContainer onAddAlertChat={onAddAlertChat} setSelectedTab={setSelectedTab} uniqueId={uniqueId} alertSearch={alertSearch} setAlertSearch={setAlertSearch} activeSeverity={activeSeverity} setActiveSeverity={setActiveSeverity} alertChildWindow={alertChildWindow} setAlertChildWindow={setAlertChildWindow} />
                </PrivateRoute> */}
                
                <PrivateRoute path={ALERTGRIDVIEW}>
                    <ProtectedAlertMosaic 
                        hootWay={hootWay}
                        setHootWay={setHootWay}
                        associateCam={associateCam}
                        setAssociateCam={setAssociateCam}
                        ResetAlertList={ResetAlertList}
                    />
                </PrivateRoute>
                
                <PrivateRoute path={ALLALERTS}>
                    <ProtectedAllAlerts alertList={alerts} selectedSubMenu={selectedSubMenu} onAddAlertChat={onAddAlertChat} setSelectedTab={setSelectedTab} alertcounts={alertcounts} ResetAlertCounts={ResetAlertCounts} alertSearch={alertSearch} setAlertSearch={setAlertSearch} activeSeverity={activeSeverity} setActiveSeverity={setActiveSeverity} childWindow={childWindow}
                        setChildWindow={setChildWindow} alertChildWindow={alertChildWindow} setAlertChildWindow={setAlertChildWindow} />
                </PrivateRoute>

                {/* <PrivateRoute path={MYALERTS}>
                    <LazyMyAlerts alertList={alerts} selectedSubMenu={selectedSubMenu} onAddAlertChat={onAddAlertChat} setSelectedTab={setSelectedTab} alertcounts={alertcounts} alertSearch={alertSearch} setAlertSearch={setAlertSearch} activeSeverity={activeSeverity} setActiveSeverity={setActiveSeverity} alertChildWindow={alertChildWindow} setAlertChildWindow={setAlertChildWindow} />
                </PrivateRoute> */}

                <PrivateRoute path={ALERTDETAILS}>
                    <ProtectedAlertDetails setSelectedTab={setSelectedTab} onAddAlertChat={onAddAlertChat} hootWay={hootWay} setHootWay={setHootWay} setSelectedSubMenu={setSelectedSubMenu}
                        setCctvTypeName={setCctvTypeName} setCamUserName={setCamUserName} setCamPassword={setCamPassword} setBrandName={setBrandName}
                    />
                </PrivateRoute>

                {/* <PrivateRoute path={DASHBOARD}>
                    <DashboardContainer alertList={alerts} setSelectedTab={setSelectedTab} alertcounts={alertcounts} todaysAlertList={todaysAlertList} rootLoading={rootLoading} onAddAlertChat={onAddAlertChat} isDarkTheme={isDarkTheme} />
                </PrivateRoute> */}

                {/* <PrivateRoute path={HOMEPAGE}>
                    <DashboardContainer alertList={alerts} setSelectedTab={setSelectedTab} alertcounts={alertcounts} todaysAlertList={todaysAlertList} rootLoading={rootLoading} onAddAlertChat={onAddAlertChat} isDarkTheme={isDarkTheme} />
                </PrivateRoute> */}

                <PrivateRoute path={DASHBOARDCHARTS}>
                    <DashboardModule />
                </PrivateRoute>

                <PrivateRoute path={ALLNOTIFICATIONS}>
                    <AllNotificationContainer />
                </PrivateRoute>


                <PrivateRoute path={REPORT_INDEX}>
                    <ReportIndex 
                        currentReport = {currentReport}
                        setCurrentReport = {setCurrentReport}
                        setReportFromDate = {setReportFromDate}
                        reportFromDate = {reportFromDate}
                        setReportToDate = {setReportToDate}
                        reportToDate = {reportToDate}/>
                </PrivateRoute>

                <PrivateRoute path={REPORT_VIEW}>
                    <ReportView
                        currentReport = {currentReport}
                        setCurrentReport = {setCurrentReport}
                        reportFromDate = {reportFromDate}
                        reportToDate = {reportToDate}  
                    />
                </PrivateRoute>

                <PrivateRoute path={REPORTS}>
                    <ProtectedReports key={2} title={"Alert Report"} showDateButton={true} reportNo={"2"} showExportButton={true} exportFileName={"Alert Report"} isPivotParent={1} />
                </PrivateRoute>

                <PrivateRoute path={EVENTACTIVITYREPORT}>
                    <ProtectedReports key={3} title={"Health Report"} showDateButton={true} reportNo={"3"} showExportButton={true} exportFileName={"Health Report"} isPivotParent={1} />
                </PrivateRoute>

                <PrivateRoute path={PANELACTIVITY}>
                    {/* <MultiColumnFilterGrid2/> */}
                    <ProtectedReports key={1} title={"Event Report"} showDateButton={true} reportNo={"1"} showExportButton={true} exportFileName={"Event Report"} isPivotParent={1} />
                </PrivateRoute>

                <PrivateRoute path={CUSTOMERACTIVITY}>
                    <ProtectedReports key={4} title={"Customer Alert Count Report"} showDateButton={true} reportNo={"4"} showExportButton={true} exportFileName={"Customer Alert Count Report"} isPivotParent={1} />
                </PrivateRoute>

                <PrivateRoute path={CUSTOMERSITEACTIVITY}>
                    <ProtectedReports key={5} title={"Customer Site Alert Count Report"} showDateButton={true} reportNo={"5"} showExportButton={true} exportFileName={"Customer Site Alert Count Report"} isPivotParent={1} />
                </PrivateRoute>

                <PrivateRoute path={OPERATORALERTREPORT}>
                    <ProtectedReports key={6} title={"Operator Alert Report"} showDateButton={true} reportNo={"6"} showExportButton={true} exportFileName={"Operator Alert Report"} isPivotParent={1} />
                </PrivateRoute>

                {/* <PrivateRoute path={DAILYHEALTHCHECKREPORT}>
                    <CommonReport key={1} title={"Daily Report"} showDateButton={false} reportNo={"3"} showExportButton={true} exportFileName={"Daily Report"} isPivotParent={1} />
                </PrivateRoute> */}

                {/* <PrivateRoute path={PANELUPDOWNREPORT}>
                    <CommonReport key={2} title={"Panel Up Down Report"} showDateButton={false} reportNo={"2"} showExportButton={true} exportFileName={"Panel Up Down Report"} isPivotParent={1} />
                </PrivateRoute> */}

                {/* <PrivateRoute path={ATMSITEREPORT}>
                    <CommonReport key={3} title={"ATM Report"} showDateButton={true} reportNo={"3"} showExportButton={true} exportFileName={"ATM Report"} isPivotParent={0} />
                </PrivateRoute> */}

                <PrivateRoute path={AVAILABLERECORDINGREPORT}>
                    <ProtectedReports key={7} title={"Available Recording Report"} showDateButton={true} reportNo={"7"} showExportButton={true} exportFileName={"Available Recording Report"} isPivotParent={1} />
                </PrivateRoute>

                <PrivateRoute path={DeviceInstallationReport}>
                    <ProtectedReports key={8} title={"Device Installation Report"} showDateButton={true} reportNo={"8"} showExportButton={true} exportFileName={"Device Installation Report"} isPivotParent={0} />
                </PrivateRoute>

                <PrivateRoute path={DeviceStageReport}>
                    <ProtectedReports key={9} title={"Device Stage Report"} showDateButton={true} reportNo={"9"} showExportButton={true} exportFileName={"Device Stage Report"} isPivotParent={0} />
                </PrivateRoute>

                <PrivateRoute path={CAMERAS}>
                        {
                            CAMERA_NEW
                            ? <ProtectedCamera childWindow={childWindow} setChildWindow={setChildWindow} /> 
                            : <CameraViewPage childWindow={childWindow}
                                setChildWindow={setChildWindow} />
                        }
                </PrivateRoute>
                <PrivateRoute path={CAMERASOLD}>
                    <CameraViewPage childWindow={childWindow} setChildWindow={setChildWindow} />
                </PrivateRoute>

                <PrivateRoute path={CAMERA_SINGLE_PLAYBACK}>
                    <LazySinglePlayback
                        setChildWindow={setChildWindow}
                    />
                </PrivateRoute>

                <PrivateRoute path={QUALITYCONTROL}>
                    <ProtectedQC childWindow={childWindow} setChildWindow={setChildWindow} onCloseAlertOnDeviceId={onCloseAlertOnDeviceId} /> 
                </PrivateRoute>

                <PrivateRoute path={PROFILE}>
                    <LazyProfileContainer checkEnableSound={checkEnableSound} />
                </PrivateRoute>
                <PrivateRoute path={CHATFLOW}>
                    <ChatflowPageContainer ResetAlertList={ResetAlertList}
                        cctvTypeName={cctvTypeName}
                        camUserName={camUserName}
                        camPassword={camPassword}
                        brandName={brandName}
                        hootWay={hootWay}
                        setHootWay={setHootWay}
                        setAlertDetail={setAlertDetail}
                        setOpenButton1={setOpenButton1}
                        openButton1={openButton1}
                        activeCam={activeCam}
                        setActiveCam={setActiveCam}
                        setCctvTypeName={setCctvTypeName}
                        setCamUserName={setCamUserName}
                        setCamPassword={setCamPassword}
                        setBrandName={setBrandName}
                        associateCam={associateCam}
                        setAssociateCam={setAssociateCam}
                    />
                </PrivateRoute>

                <PrivateRoute path={ALERTREPORT}>
                    <ProtectedAlertReport />
                </PrivateRoute>

                <PrivateRoute path={HEALTHMONITORING} exact={true}>
                    <ProtectedHealthMonitoring
                        isDarkTheme={isDarkTheme}
                    />
                </PrivateRoute>

                <PrivateRoute path={DISPLAYSITE} exact={true}>
                    <HealthDisplaySite />
                </PrivateRoute>

                <PrivateRoute path={ABOUTTERMS}>
                    <Termscondition />
                </PrivateRoute>

                <PrivateRoute path={PAGE}>
                    <CustomUrlPage />
                </PrivateRoute>

                <PrivateRoute path={PANELCONTROL}>
                    {/* <LazyPanelSetting /> */}
                    <ProtectedPanelSetting />
                </PrivateRoute>

                <PrivateRoute path={CENTRALIZERECORDING}>
                    <ProtectedCentralizeRecording />
                </PrivateRoute>

                <PrivateRoute path={MAIN_ORG}>
                    <DashboardConfigMain 
                        setSelectedTab={setSelectedTab}
                        handleModalShow={handleModalShow}
                        isDarkTheme={isDarkTheme}
                        />
                </PrivateRoute>

                <PrivateRoute path={DASHBOARD1}>
                    <Dashboard isDarkTheme={isDarkTheme}/>
                    {/* <Dashboard isDarkTheme={isDarkTheme}/> */}
                </PrivateRoute>

                <PrivateRoute path={DASHBOARD2}>
                    <MainOrg setSelectedTab={setSelectedTab} handleModalShow={handleModalShow}/>
                </PrivateRoute>

                <PrivateRoute path={ORG_DASHBOARDCONFIG}>
                    <OrgDashboard 
                    setSelectedTab={setSelectedTab}
                    handleModalShow={handleModalShow}/>
                </PrivateRoute>
                <PrivateRoute path={DOWNLOAD}>
                    <DownloadHistory/>
                </PrivateRoute>
                <Route path="*">
                    <LazyNotFound />
                </Route>
            </Switch>
        </div>

        <Modal
            show={show} 
            onHide={() => setShow(false)} 
            dialogClassName="widgetModelDiv"
            aria-labelledby="example-custom-modal-styling-title">
            <Modal.Header>
                <Modal.Title id="example-custom-modal-styling-title">
                    {/* Details */}
                    {modalHeader}
                </Modal.Title>
                <img
                    src={RemoveIcon}
                    alt="Remove"
                    style={{ cursor: "pointer" }}
                    onClick={() => {
                        setShow(false)
                    }}
                />
            </Modal.Header>
            <Modal.Body>
                <div className="d-flex mb-4 justify-content-center downloadModal">
                    {dashboardTableDataLoading ? (
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", height: "200px" }}>
                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                            <span style={{ marginTop: "1rem", color: "#888", fontWeight: 500 }}>Loading</span>
                        </div>
                    ) : dashboardTableDataError ? (
                        <div style={{ color: "red", textAlign: "center", marginTop: "2rem" }}>
                            {dashboardTableDataError}
                        </div>
                    ) : (
                        <TableDetails tableData={dashboardTableData} csvFileName={csvFileName} exportRequestParams={tableRequestParams}/>
                    )}
                </div>
                </Modal.Body>
        </Modal>
    </>
}
